import React, { useState, useEffect } from 'react';
import { Loader } from 'lucide-react';
import { FamilyCreation } from './FamilyCreation';
import { GardenBackground } from '../components/ui';

export const OnboardingFamilyCreation = ({ onNavigate, onFamilyCreated }) => {
  const [onboardingData, setOnboardingData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const API_BASE_URL = 'https://growthsprouts-server.vercel.app';

  useEffect(() => {
    const loadOnboardingData = async () => {
      const email = localStorage.getItem('onboardingEmail');
      const code = localStorage.getItem('onboardingCode');

      if (!email || !code) {
        setError('Missing email or invite code');
        setLoading(false);
        return;
      }

      try {
        const response = await fetch(
          `${API_BASE_URL}/api/auth/onboarding?email=${encodeURIComponent(email)}&code=${encodeURIComponent(code)}`
        );
        const result = await response.json();

        if (result.success) {
          setOnboardingData(result.data);
        } else {
          setError(result.error || 'Invalid email and invite code combination');
        }
      } catch (error) {
        setError('Error validating onboarding credentials');
      } finally {
        setLoading(false);
      }
    };

    loadOnboardingData();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen relative flex items-center justify-center">
        <GardenBackground />
        <div className="relative z-10 text-center">
          <Loader className="w-6 h-6 text-emerald-600 animate-spin mx-auto mb-3" />
          <p className="text-sm text-gray-500">Loading your account setup...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen relative flex items-center justify-center px-4">
        <GardenBackground />
        <div className="relative z-10 text-center max-w-sm">
          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6">
            <p className="text-red-600 text-sm mb-4">{error}</p>
            <button
              onClick={() => onNavigate('welcome')}
              className="text-sm text-emerald-600 hover:text-emerald-700"
            >
              Go to main page
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <FamilyCreation
      onNavigate={onNavigate}
      onFamilyCreated={onFamilyCreated}
      onboardingData={onboardingData}
    />
  );
};